<template>
  <div class="spinnerholder" v-if="isSearching" >
    <SpinText
      :text="$t('apesquisar')"
      class="spinner"/>
  </div>
  <List
    v-else 
    :listItems="listItems">
    <pagination
      @changePage="getPage"
      @loadmore="loadmore"
      :showPagination="listItems.length > 0"
      :numberOfPages="numberOfPages"
      :currentPage="currentPage" />
  </List>
  <Nodocs v-if="listItems.length == 0 && !isSearching"/>
</template>

<script>
import axios from "@/axios";
import { ref } from 'vue';
import pagination from '@/components/pagination.vue';
import List from "@/components/eleicoeslist/list.vue";
import Nodocs from "@/components/nodocs.vue";
import { SpinText } from "umaui";
import { i18n } from "@/main";


export default {
  components:{
    pagination,
    SpinText,
    List,
    Nodocs
  },
  setup () {

    const listItems = ref([]);
    const currentPage = ref(1);
    const pages = ref(0);
    const limit = 10;
    const numberOfPages = ref(0)
    const filter = ref(null);

    const getPage = (page) => {
      window.scrollTo(0,0);
      currentPage.value = page;
      fetchDocuments();
    };

    const loadmore = () => {
      currentPage.value = currentPage.value + 1;
      fetchDocuments(true);
    };

    const searchWord = searchfilter => {
      if(searchfilter.length > 2){
        currentPage.value = 1;
        filter.value = searchfilter;
        fetchDocuments();
      }else{
        currentPage.value = 1;
        filter.value = "";
        fetchDocuments();
      }
    };

    const calculateSearchParameters = () => {
      let params = new URLSearchParams({
        limit: limit,
        offset: (currentPage.value - 1) * limit,
        //owner: import.meta.env.VITE_UID,
        publicado: 1, 
        //sort:"doc_ano",
        idioma: i18n.global.locale,
      });
      if (filter.value != null) {
        params.append('filter', filter.value);
      }
      return `?${params.toString()}`;
    }

    const isSearching = ref(true)

    let controller = new AbortController();

    const fetchDocuments = (shouldAdd = false) => {
      if (controller) {
        controller.abort();
      }
      controller = new AbortController();
      isSearching.value = true && !shouldAdd;
      axios.get('/eleicoescg' + calculateSearchParameters(),{
          signal: controller.signal
        })
        .then(data => {
          listItems.value = !shouldAdd ? data.data.data : 
                        [...listItems.value, ...data.data.data];
          numberOfPages.value = Math.ceil(data.data.total / limit);
          isSearching.value = false;

          console.log(listItems.value);
        })
        .catch(error => {
          if(error.name != "CanceledError"){
            isSearching.value = false;
          }
          console.log(error);
        })
    }

    fetchDocuments()

    return {
      isSearching,
      searchWord,
      listItems,
      currentPage,
      pages,
      getPage,
      loadmore,
      numberOfPages
    };
  }
}
</script>

<style scoped>
.spinnerholder{
  position: relative;
  margin-top: 50px;
}

@media screen and (max-width: 767px) {
  .spinnerholder{
    display: none;
  }
}
</style>